import AppHeader from '../Components/AppHeader';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { getFirebaseAuthModule } from '../../Repository/Authentication/Firebase';
import { useMediaQuery, useTheme } from '@mui/material';


export default function MediaLayout() {
    const theme = useTheme();
    const small = useMediaQuery(theme.breakpoints.down('md'));
    const { pathname } = useLocation();
    const isCreateQr = pathname === '/create-qr' || pathname.endsWith('/create-qr');
    const isWatch = pathname === '/watch';
    const hideHeader = isWatch || (small && isCreateQr);

    useEffect(() => {
        const auth = getFirebaseAuthModule();
        auth.onAuthStateChanged((user) => {
            if (user) {
                user.getIdToken().then((newToken) => {
                    localStorage.setItem("JWTTOKEN", newToken);
                   
                });
            } else {
                return ((error => {console.log(error)}))
            }
        }
        );
      }, []);
    return (
        <section
            style={{
                overflow: isWatch ? "hidden" : undefined,
                height: isWatch ? "100dvh" : undefined,
                maxHeight: isWatch ? "100dvh" : undefined,
                display: isWatch ? "flex" : undefined,
                flexDirection: isWatch ? "column" : undefined,
                backgroundColor: isWatch ? "#000" : undefined,
            }}
        >
            {!hideHeader && <AppHeader type='floating' />}
            <Outlet />
        </section>
    )
}